import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import * as _ from 'lodash'

import Phone from '../shared/Phone'
import PopoverContainer from './PopoverContainer'
import Overlay from './Overlay'
import HiddenOverlay from './HiddenOverlay'
import { applyCustomFields } from 'controllers/logic'
import { getTemplateByApp, getTemplateInfo } from 'templates/templates'
import { changeBodyDarkened } from 'actions/guiAC'
import { changeEditorScene } from 'actions/locationAC'
import { media, ALMOST_WHITE } from '../styles'
import InstaEditApp from './insta/InstaEditApp'
import * as templateCategory from 'constants/templateCategory'
import * as editorModes from 'constants/editorMode'
import { POSITION } from 'constants/stylePresetType'

const Container = styled.div`
  width: 100%;
  height: 100%;

  position: relative;
  ${media.small`font-size: 20px;`}
  ${media.huge`font-size: 26px;`}
  background: ${ALMOST_WHITE};
`
const OverlayContainer = styled.div`
  text-align: center;
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  z-index: 500;
`
const CenteredLayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 3% 0;
  z-index: 2;
`

class EditApp extends Component {

  constructor (props) {
    super(props)
    this.state = {
      template: getTemplateByApp(props.app),
      selectedFieldLabel: -1,
      hoverFieldLabel: -1,
      hideOverlay: false,
      hoveredElement: '',
      disableHover: false,
      popoverSection: '',
      isEditorPopoverVisible: false,
      isEditingText: false
    }
    this.ignorePopoverOusideClick = false
  }

  componentWillReceiveProps (nextProps) {
    // console.log('componentWillReceiveProps, location', nextProps.location)
    this.setState({
      template: getTemplateByApp(nextProps.app)
    })
    if (this.props.location.sceneNum !== nextProps.location.sceneNum ||
        this.props.editorMode !== nextProps.editorMode) {
      this.onChangeSelectedField(-1)
    }

  }

  selectFieldLabel = (fieldNum) => {
    if (fieldNum === this.state.selectedFieldLabel && !this.props.isEditorPopoverVisible) {
      this.onChangeSelectedField(-1)
    } else {
      this.onChangeSelectedField(fieldNum)
    }
  }

  setPopoverSection = (section) => {
    this.setState({popoverSection: section})
  }

  disableHover = () => {
    this.setState({disableHover: true})
  }

  enableHover = () => {
    this.setState({disableHover: false})
  }

  openEditMenu = (fieldNum) => {
    this.selectFieldLabel(fieldNum)
    this.setState({isEditorPopoverVisible: true})
    this.onHoverField(-1)
  }

  setIsEditingText = (value) => {
    this.setState({isEditingText: value})
  }

  hideOverlay = () => this.setState({ hideOverlay: true })
  showOverlay = () => this.setState({ hideOverlay: false })

  setIgnorePopoverOusideClick = (v) => {
    this.ignorePopoverOusideClick = v
  }

  onOverlayClick = (field) => {
    return () => {
      if (this.state.isEditingText || this.state.isEditorPopoverVisible) {
        return
      }
      if (!this.state.disableHover && this.state.hoverFieldLabel !== -1) {
        let positionPreset
        if (field.stylePresets) {
          positionPreset = field.stylePresets.find(preset => (preset.presetType === POSITION))
        } else {
          positionPreset = undefined
        }
        if (!positionPreset) {
          return
        }
        this.setState({disableHover: true})
      }
    }
  }

  onOverlayHover = (field, index) => {
    if (!this.state.disableHover && !this.state.isEditingText) {
      if (this.state.hoveredElement !== field.overlayKey) {
        this.setState({hoveredElement: field.overlayKey})
        this.onHoverFieldArea(index)
      }
    }
  }

  renderOverlay () {
    const { app, location, editorMode } = this.props
    const { template, selectedFieldLabel, hoverFieldLabel } = this.state
    const customFieldsConf = template.customFields
    const scene = customFieldsConf[location.sceneNum]
    let fieldNum = selectedFieldLabel
    if (fieldNum < 0) fieldNum = hoverFieldLabel
    if (editorMode === editorModes.EDIT) {
      return (
        <OverlayContainer>
          {_.map(scene.fields, (field, index) => {
            const isVisible = hoverFieldLabel === index
            if (isVisible) {
              return (
                <Overlay
                  id={'overlayContainer'}
                  key={index}
                  field={field}
                  fieldNum={index}
                  openEditMenu={fieldNum => this.openEditMenu(fieldNum)}
                  app={app}
                  setPopoverSection={this.setPopoverSection}
                  setIgnorePopoverOusideClick={this.setIgnorePopoverOusideClick}
                  updateOverlayHack={this.state.updateOverlayHack}
                  hoverDisabled={this.state.disableHover}
                  disableHover={this.disableHover}
                  enableHover={this.enableHover}
                  moving={this.state.disableHover}
                  isEditorPopoverVisible={this.props.isEditorPopoverVisible}
                  settings={template.settings}
                  setIsEditingText={this.setIsEditingText}
                  isEditingText={this.state.isEditingText}
                  activeButton={this.state.popoverSection}
                  onClick={this.onOverlayClick(field)}
                />
              )
            } else if (!this.props.isEditorPopoverVisible) {
              return (
                <HiddenOverlay
                  key={index}
                  app={app}
                  field={field}
                  fieldNum={index}
                  isEditingText={this.state.isEditingText}
                  onOverlayHover={this.onOverlayHover}
                />
              )
            }
          })}
        </OverlayContainer>
      )
    }
  }


  compareScenes (iaScene, customFieldsScene) {
    if (_.isObject(customFieldsScene)) {
      for (const p in customFieldsScene) {
        // console.log('p', p, 'iaValue', iaScene[p], 'cfValue', customFieldsScene[p], 'equal', iaScene[p] === customFieldsScene[p])
        if (iaScene[p] !== customFieldsScene[p]) return false
      }
      return true
    } else {
      return iaScene === customFieldsScene
    }
  }

  handleSceneChange = (v) => {
    // console.log('handleSceneChange', v)
    const { dispatch, location } = this.props
    const { template } = this.state
    const customFieldsConf = template.customFields
    let sceneNum = null
    // const omitedV = _.omitBy(v, _.isNil)
    for (const i in customFieldsConf) {
      const cf = customFieldsConf[i]
      const equal = this.compareScenes(v, cf.location)
      // console.log('cur location', cf.location, 'IA location', v, 'equal', equal)
      if (equal) {
        sceneNum = Number(i)
        break
      }
    }
    // console.log('sceneNum', sceneNum, 'current', location.sceneNum)
    if (sceneNum !== null && sceneNum !== location.sceneNum) {
      // console.log('changeEditorScene', sceneNum)
      dispatch(changeEditorScene(sceneNum))
      this.onChangeSelectedField(-1)
    }
  }

  renderInstantApp () {
    const { app, location, dispatch, editorMode } = this.props
    const { template } = this.state
    // console.log('renderInstantApp, location', location.sceneNum)
    const settings = template.settings
    const customFieldsConf = template.customFields
    let customisedSettings = settings
    if (_.has(app, 'customFields')) {
      customisedSettings = applyCustomFields(app.customFields, settings)
    }
    const _InstantApp = getTemplateInfo(template.id).instantApp
    // console.log('sceneNum', sceneNum, 'fieldNum', fieldNum, 'customFieldsConf', customFieldsConf)
    const scene = _.clone(customFieldsConf[location.sceneNum])
    // console.log('customisedSettings', customisedSettings)
    if (editorMode === editorModes.EDIT) {
      return (
        <_InstantApp
          appId={app.id}
          templateId={template.id}
          settings={customisedSettings}
          onChange={this.handleSceneChange}
          location={scene.location}
          editMode
          dispatch={dispatch}
        />
      )
    } else {
      return (
        <_InstantApp
          // key={app.id}
          appId={app.id}
          templateId={template.id}
          settings={customisedSettings}
          showcaseMode
          editMode={false}
          location={scene.location}
          onChange={this.handleSceneChange}
        />
      )
    }
  }

  switchSceneToPrev = () => {
    const { dispatch, location } = this.props
    if (location.sceneNum > 0) {
      dispatch(changeEditorScene(location - 1))
    }
  }

  switchSceneToNext = () => {
    const { dispatch, location } = this.props
    const { template } = this.state
    const customFieldsConf = template.customFields
    if (location.sceneNum < customFieldsConf.length - 1) {
      dispatch(changeEditorScene(location.sceneNum + 1))
    }
  }

  onChangeSelectedField = (fieldNum) => {
    this.setState({ selectedFieldLabel: fieldNum })
    if (fieldNum === -1) {
      this.setState({
        hoveredElement: '',
        popoverSection: '',
        hoverFieldLabel: -1
      })
      setTimeout(() => {
        this.setState({isEditorPopoverVisible: false})
      }, 100) //this timeout is needed in order not to enter moving-mode if click on field with editor being opened
    }

    this.props.dispatch(changeBodyDarkened(fieldNum !== -1))
  }

  componentWillUnmount () {
    this.props.dispatch(changeBodyDarkened(false))
  }

  onHoverFieldArea = (fieldNum) => {
    this.setState({ hoverFieldLabel: fieldNum })
  }

  onHoverField = (fieldNum) => {
    if (this.state.disableHover) {
      this.setState({ disableHover: false, hoverFieldLabel: fieldNum, hoveredElement: '' })
    }
    this.setState({ hoverFieldLabel: fieldNum, hoveredElement: '' })
  }

  renderFields () {
    return null
    // const { location, editorMode } = this.props
    // if (editorMode === editorModes.EDIT) {
    //   const { template, selectedFieldLabel } = this.state
    //   const customFieldsConf = template.customFields
    //   const scene = customFieldsConf[location.sceneNum]
    //   if (scene && scene.fields && scene.fields.length > 0) {
    //     return (
    //       <FieldLabels
    //         fields={assignProductNamesToFieldTitles(scene.fields, this.props.app, template.settings)}
    //         selectedFieldLabel={selectedFieldLabel}
    //         onChangeSelectedField={this.onChangeSelectedField}
    //         onHoverField={this.onHoverField}
    //       />
    //     )
    //   }
    // }
    //
    // function assignProductNamesToFieldTitles (fields, app, settings) {
    //   fields.forEach(field => {
    //     if (field.type === SHOPIFY_PRODUCT || field.type === PRODUCT) {
    //       const titleObject = _.get(app.customFields, field.paths[0], _.get(settings, field.paths[0]))
    //       field.name = titleObject.title
    //     }
    //     // else if (field.type === PRODUCT) {
    //     //   field.name = _.get(app.customFields, field.paths[0], _.get(settings, field.paths[0]))
    //     // }
    //
    //     return field
    //   })
    //
    //   return fields
    // }
  }

  getIgnorePopoverOusideClick = () => {
    return this.ignorePopoverOusideClick
  }

  renderPopover () {
    const { app, location } = this.props
    const { template, selectedFieldLabel } = this.state
    const customFieldsConf = template.customFields
    const scene = customFieldsConf[location.sceneNum]
    if (scene && scene.fields && scene.fields.length > 0 && selectedFieldLabel >= 0) {
      const field = scene.fields[selectedFieldLabel]
      if (field) {
        return (
          <PopoverContainer
            closeMyself={() => this.onChangeSelectedField(-1)}
            isVisible={selectedFieldLabel >= 0}
            fieldLabelId={`tab_${selectedFieldLabel}`}
            field={field}
            popoverSection={this.state.popoverSection}
            app={app}
            settings={template.settings}
            getIgnorePopoverOusideClick={this.getIgnorePopoverOusideClick}
            setIgnorePopoverOusideClick={this.setIgnorePopoverOusideClick}
          />
        )
      }
    }
  }

  render () {
    const { app, location, isEditorPopoverVisible, editorMode } = this.props
    const templateInfo = getTemplateInfo(app.templateId)
    // we have a specific UI for instagram editor starting from the second scene
    if (templateInfo.category === templateCategory.INSTAGRAM_SHOPPABLE && location.sceneNum > 1) {
      return <InstaEditApp app={app} />
    } else {
      return (
        <Container>
          <CenteredLayer>
            <Phone
              fields={this.renderFields()}
              isEditorPopoverVisible={isEditorPopoverVisible}
              needOffset={editorMode === editorModes.EDIT}
            >
              {this.renderInstantApp()}
              {this.renderOverlay()}
            </Phone>
            {this.renderPopover()}
          </CenteredLayer>
        </Container>
      )
    }
  }
}

EditApp.defaultProps = {
  isEditorPopoverVisible: false,
  editorMode: editorModes.EDIT
}

EditApp.propTypes = {
  app: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isEditorPopoverVisible: PropTypes.bool,
  editorMode: PropTypes.string
}

const mapStateToProps = state => ({
  location: state.location,
  isEditorPopoverVisible: state.gui.isEditorPopoverVisible,
})

export default connect(mapStateToProps)(EditApp)



// WEBPACK FOOTER //
// ./src/components/editor/EditApp.js